import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const { BreakpointNames } = constants.breakpoints;
const grey = constants.colors.ui.neutral[25];
export const PrintModalZIndex = 14;

const shareModalRootCss = {
  /**
   * Match GlobalLayout header z-index, otherwise the logo
   * and user dropdown will appear above the modal.
   */
  zIndex: 14,
};

const shareModalContentWrapperCss = {
  padding: 0,
  [mq.downTo(BreakpointNames.xs)]: {
    maxWidth: "550px",
  },
  [mq.upTo(BreakpointNames.sm)]: {
    height: "auto !important",
  },
};

const shareModalBodyCss = {
  display: "grid",
  gridTemplateColumns: "420px",
  [mq.upTo(BreakpointNames.xs)]: {
    gridTemplateColumns: "1fr",
    width: "80%",
  },
  placeContent: "center",
  flexGrow: 1,
  margin: "auto",
};

export const shareModalCss = {
  modalContentWrapper: shareModalContentWrapperCss,
  root: shareModalRootCss,
  scrollableBody: shareModalBodyCss,
};

export const ulCss: CSSObject = {
  margin: 0,
  padding: 0,
  listStyle: "none",
};

export const checkBoxAndTooltipContainerCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  backgroundColor: grey,
  paddingLeft: "10px",
  marginTop: "8px",
};

export const optionCss: CSSObject = {
  width: "auto",
};

export const ecoModeToggleCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  padding: "10px 10px 20px",
};

export const radioOptionsWrapperCss: CSSObject = {
  display: "flex",
  gap: "18px",
};

export const wrapperCss: CSSObject = {
  overflow: "visible",
  height: "270px",
  marginBottom: "40px",
};

export const fieldsetCss: CSSObject = {
  margin: 0,
  padding: 0,
  border: "none",
};

export const footerButtonsWrapper = {
  display: "flex",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  flex: "0 0 auto",
  "&> button:last-child": {
    flex: "0 0 auto",
    marginLeft: "auto",
  },
  "&>button:nth-of-type(2)": {
    marginRight: 0,
  },
};
